class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    if (!window.upsellNudged) {

  window.upsellNudged = true;

  setTimeout(() => {

    const slider = document.querySelector('.cart-drawer-upsells-scroll');

    if (!slider) return;

    slider.scrollBy({
      left: 90,
      behavior: 'smooth'
    });

    setTimeout(() => {

      slider.scrollTo({
        left: 0,
        behavior: 'smooth'
      });

    }, 700);

  }, 1200);
}
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble' },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

document.addEventListener('click', function (e) {
  if (!e.target.classList.contains('upsell-qty-btn')) return;

  const action = e.target.dataset.action;
  const wrapper = e.target.closest('.upsell-qty');
  const input = wrapper.querySelector('.upsell-qty-input');

  let value = parseInt(input.value, 10);

  if (action === 'increase') value++;
  if (action === 'decrease' && value > 1) value--;

  input.value = value;
});


document.addEventListener('click', function (e) {
  if (!e.target.classList.contains('upsell-add-btn')) return;

  const btn = e.target;
  const variantId = btn.dataset.variantId;

  const controls = btn.closest('.upsell-controls');
  const qtyInput = controls ? controls.querySelector('.upsell-qty-input') : null;
  const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

  const isAdded = btn.dataset.added === 'true';

  btn.disabled = true;

  if (isAdded) {
    btn.innerText = 'Removing...';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 0 })
    })
    .then(() => {
      btn.innerText = 'Add';
      btn.dataset.added = 'false';
      btn.classList.remove('upsell-added');
      btn.disabled = false;
    });

    return;
  }

  btn.innerText = 'Adding...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: quantity })
  })
  .then(() => {
    btn.innerText = 'Remove';
    btn.dataset.added = 'true';
    btn.classList.add('upsell-added');
    btn.disabled = false;
  });
});
document.addEventListener('click', function(e) {

  const leftBtn = e.target.closest('.upsell-scroll-left');
  const rightBtn = e.target.closest('.upsell-scroll-right');

  if (!leftBtn && !rightBtn) return;

  const container = e.target
    .closest('.cart-upsells-container')
    .querySelector('.cart-drawer-upsells-scroll');

  const maxScroll =
    container.scrollWidth - container.clientWidth;

  if (rightBtn) {

    if (container.scrollLeft >= maxScroll - 10) {

      container.scrollTo({
        left: 0,
        behavior: 'smooth'
      });

    } else {

      container.scrollBy({
        left: 320,
        behavior: 'smooth'
      });

    }
  }

  if (leftBtn) {

    if (container.scrollLeft <= 10) {

      container.scrollTo({
        left: maxScroll,
        behavior: 'smooth'
      });

    } else {

      container.scrollBy({
        left: -320,
        behavior: 'smooth'
      });

    }
  }

});
setTimeout(() => {
  const slider = document.querySelector('.cart-drawer-upsells-scroll');

  if (!slider) return;

  slider.scrollBy({
    left: 80,
    behavior: 'smooth'
  });

  setTimeout(() => {
    slider.scrollTo({
      left: 0,
      behavior: 'smooth'
    });
  }, 900);

}, 1200);